export function matchesPeopleSearch(profile, query) {
    if (!query) {
        return true;
    }

    const normalizedQuery = query.trim().toLowerCase();

    return [profile?.full_name, profile?.email].some((value) => {
        if (value == null || value === "") {
            return false;
        }

        return String(value).trim().toLowerCase().includes(normalizedQuery);
    });
}

export function filterPeople(people, query) {
    return people.filter((person) => matchesPeopleSearch(person, query));
}
